module.exports = require("spdx-expression-parse");